pollsPresenter.directive('pollsPresenter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'polls_presenter/templates/' + helperService.getRedesignPathPrefix() + 'pollsPresenter.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
